import backButtonIcon from "../../assets/images/back-button-icon.png";
import React from "react";
import { useHistory } from "react-router";

export const BackButton = () => {
  const history = useHistory();

  return (
    <div
      style={{
        backgroundColor: "transparent",
        height: 46,
        width: 46,
        borderRadius: 5,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        cursor: "pointer",
      }}
      role="presentation"
      onClick={() => history.goBack()}
    >
      <img
        src={backButtonIcon}
        style={{ width: 46, height: 46 }}
        alt="back-button-icon"
      />
    </div>
  );
};
